import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { env } from '../../constants/env';

export type ReznorHttpConfig = {
  url: string;
  token: string;
  headers?: { [k: string]: string };
  transformResponse?: AxiosRequestConfig['transformResponse'];
  responseType?: AxiosRequestConfig['responseType'];
};

type HTTP = {
  get<T = unknown, R = AxiosResponse<T>>(config: ReznorHttpConfig): Promise<R>;
  post<T = unknown, R = AxiosResponse<T>>(
    config: ReznorHttpConfig,
    data?: unknown
  ): Promise<R>;
};

const buildAuthHeader = (token: string) => ({
  Authorization: `Bearer ${token}`,
});

export const http: HTTP = {
  get: config => {
    return axios.request({
      method: 'get',
      responseType: 'json',
      baseURL: env.reznorHostname,
      ...config,
      headers: { ...buildAuthHeader(config.token), ...config.headers },
    });
  },
  post: (config, payload) => {
    return axios.request({
      method: 'post',
      responseType: 'json',
      baseURL: env.reznorHostname,
      data: payload,
      ...config,
      headers: { ...buildAuthHeader(config.token), ...config.headers },
    });
  },
};
